import React from 'react';
import { Goal, UpdateGoal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export enum ContextMenuOptions {
  Archive = 'archive',
  Delete = 'delete',
  ShowRoadmap = 'showRoadmap',
}

export type GroupingGoalListProps = {
  goals: Goal[];
  collapsedGoals?: ID[];
  onGoalCollapse?: (ids: ID[]) => void;
  scrollElement?: React.RefObject<HTMLDivElement>;
  onReorder?: (
    updatedSections: { id: ID; goalSorting: ID[] }[],
    updatedGoals: UpdateGoal[],
  ) => void;
  onUpdateProgress: (id: string) => void;
  hideLifeArea?: boolean;
  hideArchived?: boolean;
  hideCompleted?: boolean;
  isMultiSelectModifierPressed?: boolean;
  excludedContextMenuOptions?: ContextMenuOptions[];
};
